import { ChangeDetectorRef, Component, OnInit, Input } from "@angular/core";
import { ApiService } from "../../services";
import { LoadingScreenService } from "../../shared/loading-screen.service";
import { ModalService } from "../../shared/modal.service";
import { IUserProfile } from "../../npr-request.model";
import { Comment } from "../../generated-models/Comment";
import { ToastrService } from "ngx-toastr";
import { BaseComponent } from "../../shared/base.component";

@Component({
  standalone: false,
  selector: "latest-pf-plan-comments",
  templateUrl: "./latest-pf-plan-comments.component.html",
  styleUrls: ["../../styles.scss"],
})
export class LatestPfPlanCommentsComponent extends BaseComponent implements OnInit {
  @Input() serviceTreeId: string;
  @Input() version: number;

  readonly newCommentPlaceHolder: string = "Type your comment here...";
  readonly region: string = "*";
  readonly blueprint: string | null = null;
  readonly topic: string = "PF";

  userProfile: IUserProfile = null;

  comments: Comment[] = [];
  newComment: string = "";

  constructor(
    protected modalService: ModalService,
    protected apiService: ApiService,
    protected loadingService: LoadingScreenService,
    protected notificationService: ToastrService,
    protected cdr: ChangeDetectorRef
  ) {
    super();
  }

  /**
   * Component initialization
   */
  async ngOnInit() {
    this.loadingService.setLoading(true);

    await this.loadUserProfile()
    await this.loadComments();

    this.loadingService.setLoading(false);
    this.cdr.detectChanges();
  }

  /**
   * Loads user profile
   */
  async loadUserProfile()
  {
    this.loadingService.setLoading(true);

    try {
      this.userProfile = await this.apiService.getUserProfile();
    } catch (error) {
      this.notificationService.error(`Error loading user profile: ${error}`);
    }

    this.loadingService.setLoading(false);
  }

  /**
  * Loads latest comments
  */
  async loadComments() {
    this.loadingService.setLoading(true);

    try {
      this.comments = await this.apiService.getLatestPfPlanComments(this.serviceTreeId).toPromise();
      this.comments.sort((a, b) => new Date(b.At).getTime() - new Date(a.At).getTime()); // Sort in reverse chronological order from latest to earliest
    } catch (error) {
      this.notificationService.error(`Error loading comments: ${error}`);
    }

    this.loadingService.setLoading(false);
  }

  /**
   * Validates if the current comment is valid for submission
   */
  isValidComment() {
    if (this.newComment) {
      return this.newComment.trim().length != 0;
    }
    return false;
  }

  /**
  * Saves a new comment
  */
  async saveNewComment() {
    if (!this.isValidComment()) {
      return;
    }

    this.loadingService.setLoading(true);

    const comment: Comment = {
      Version: this.version,
      Topic: this.topic,
      Comment: this.newComment.trim(),
      By: this.userProfile.Name,
      At: new Date()
    };

    try {
      await this.apiService.addComment(this.serviceTreeId, this.region, this.version, this.blueprint, comment).toPromise();
      this.newComment = "";
      await this.loadComments();
      this.notificationService.info("Comment added successfully");
    } catch (error) {
      this.notificationService.error(`Error adding comment: ${error}`);
    }

    this.loadingService.setLoading(false);
  }
}
